import { useState } from "react";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";

export default function HotArticles() {
  const [active, setActive] = useState<string>("all");

  const filtered =
    active === "all"
      ? articles.slice(0, 6)
      : articles.filter((item) => item.category === active).slice(0, 6);

  return (
    <section
      id="hot"
      aria-labelledby="hot-title"
      className="border-y border-background-200 bg-background-100"
    >
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-4 border-b border-background-200 pb-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-500" />
              热门爆料
            </p>
            <h2 id="hot-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              此刻最多人在看的爆料
            </h2>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => setActive("all")}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                active === "all"
                  ? "bg-foreground-950 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              全部
            </button>
            {categories.map((item) => (
              <button
                key={item.slug}
                type="button"
                onClick={() => setActive(item.slug)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  active === item.slug
                    ? "bg-foreground-950 text-background-50"
                    : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((item) => (
              <ArticleCard key={item.id} article={item} />
            ))}
          </div>
        ) : (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-50 px-5 py-10 text-center text-sm text-foreground-600">
            这个栏目暂时还没有爆料内容，换个分类看看吧。
          </p>
        )}
      </div>
    </section>
  );
}